import { render, staticRenderFns } from "./signup-code.vue?vue&type=template&id=0979a282&scoped=true&"
import script from "./signup-code.vue?vue&type=script&lang=js&"
export * from "./signup-code.vue?vue&type=script&lang=js&"
import style0 from "./signup-code.vue?vue&type=style&index=0&id=0979a282&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0979a282",
  null
  
)

export default component.exports